import { ModuleIOValueTypeEnum } from "@packages/flow-core/module";

export const FlowValueTypeMap = {
  [ModuleIOValueTypeEnum.string]: {
    handlerStyle: {
      background: "#8ab1d0",
    },
    label: '"字符串"类型',
    value: ModuleIOValueTypeEnum.string,
    description: "",
  },
  [ModuleIOValueTypeEnum.number]: {
    handlerStyle: {
      background: "#6eb8a7",
    },
    label: `"数字"类型`,
    value: ModuleIOValueTypeEnum.number,
    description: "",
  },
  [ModuleIOValueTypeEnum.boolean]: {
    handlerStyle: {
      background: "#6e9d6f",
    },
    label: `"布尔"类型`,
    value: ModuleIOValueTypeEnum.boolean,
    description: "",
  },
  [ModuleIOValueTypeEnum.chatHistory]: {
    handlerStyle: {
      background: "#5ba697",
    },
    label: '"聊天记录"类型',
    value: ModuleIOValueTypeEnum.chatHistory,
    description: `{
  obj: System | Human | AI;
  value: string;
}[]`,
  },
  [ModuleIOValueTypeEnum.datasetQuote]: {
    handlerStyle: {
      background: "#ee7f7b",
    },
    label: '"引用内容"类型',
    value: ModuleIOValueTypeEnum.datasetQuote,
    description: `{
  id: string;
  datasetId: string;
  collectionId: string;
  sourceName: string;
  sourceId?: string;
  q: string;
  a: string
}[]`,
  },
  [ModuleIOValueTypeEnum.any]: {
    handlerStyle: {
      background: "#d3ad4c",
    },
    label: '"任意"类型',
    value: ModuleIOValueTypeEnum.any,
    description: "",
  },
  [ModuleIOValueTypeEnum.kv]: {
    handlerStyle: {
      background: "#73abbf",
    },
    label: '"属性"类型',
    value: ModuleIOValueTypeEnum.kv,
    description: "",
  },
  [ModuleIOValueTypeEnum.stringArray]: {
    handlerStyle: {
      background: "#8d8ae5",
    },
    label: '"字符串数组"类型',
    value: ModuleIOValueTypeEnum.stringArray,
    description: "",
  },
  [ModuleIOValueTypeEnum.tools]: {
    handlerStyle: {
      background: "#c19de3",
    },
    label: "工具",
    value: ModuleIOValueTypeEnum.tools,
    description: "",
  },
  [ModuleIOValueTypeEnum.numberCompare]: undefined,
  [ModuleIOValueTypeEnum.map]: undefined,
  [ModuleIOValueTypeEnum.fieldDescription]: undefined,
};
